import {
  getLocalizedAwardType,
  getLocalizedProductName,
} from './multilingual';

export const formatRewardApprovalDetail = reward => {
  const award = reward?.level_award;
  if (!award) {
    return reward?.code || '—';
  }

  const label = getLocalizedAwardType(award);
  if (award.gift_display) {
    const giftName = getLocalizedProductName(award.gift_display);
    if (giftName && giftName !== '-') {
      return `${label} — ${giftName}`;
    }
  }
  if (award.discount && !award.points) {
    return `${label} (${award.discount}%)`;
  }
  return label || reward?.code || '—';
};

export const formatGiftApprovalDetail = gift => {
  if (gift?.gift_display) {
    const name = getLocalizedProductName(gift.gift_display);
    if (name && name !== '-') {
      return name;
    }
  }
  return '—';
};
